import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'adc-file-upload',
  templateUrl: './adc-file-upload.component.html',
  styleUrls: ['./adc-file-upload.component.scss'],
  standalone: false
})
export class AdcFileUploadComponent{
  @Input() type: any;
  @Input() fileName: string | null = null;
  @Input() fileNames: { name: string; file: File }[] = [];
  @Input() uploadProgress2: number = 0;
  @Input() showProgress2: boolean = false;
  @Input() uploadProgress: number = 0;
  @Input() showProgress: boolean = false;
  @Output() fileSelected = new EventEmitter<Event>();
  @Output() dropEvent = new EventEmitter<DragEvent>();
  @Output() dragOverEvent = new EventEmitter<DragEvent>();
  @Output() resetUploadEvent = new EventEmitter<void>();
  @Output() filesSelected = new EventEmitter<Event>();
  @Output() dropEvent2 = new EventEmitter<DragEvent>();
  @Output() dragOverEvent2 = new EventEmitter<DragEvent>();
  @Output() removeFile = new EventEmitter<number>();

  onFileSelected(event: Event) {
    this.fileSelected.emit(event);
  }

  onDrop(event: DragEvent) {
    this.dropEvent.emit(event);
  }

  onDragOver(event: DragEvent) {
    this.dragOverEvent.emit(event);
  }

  resetUpload() {
    this.resetUploadEvent.emit();
  }

  onFilesSelected(event: Event) {
    this.filesSelected.emit(event);
  }

  onDrop2(event: DragEvent) {
    this.dropEvent.emit(event);
  }

  onDragOver2(event: DragEvent) {
    this.dragOverEvent.emit(event);
  }

  removeFileAt(index: number) {
    this.removeFile.emit(index);
  }
}
